import React from 'react';
import type { UserAdminView } from '../../../services/users/users.service';
import classes from '../users-page.module.scss';

type UsersTableProps = {
  users: UserAdminView[];
  isLoadingUsers: boolean;
  expandedUserId: number | null;
  onToggleExpanded: (userId: number) => void;
  onEditUser: (user: UserAdminView) => void;
  onDeactivateUser: (user: UserAdminView) => void;
  onActivateUser: (user: UserAdminView) => void;
};

export const UsersTable: React.FC<UsersTableProps> = ({
  users,
  isLoadingUsers,
  expandedUserId,
  onToggleExpanded,
  onEditUser,
  onDeactivateUser,
  onActivateUser,
}) => {
  return (
    <div className={classes.tableWrap}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>שם תצוגה</th>
            <th>שם משתמש</th>
            <th>דוא"ל</th>
            <th>תפקיד</th>
            <th>חברה ראשית</th>
            <th>סטטוס</th>
            <th>נוצר בתאריך</th>
            <th>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const isExpanded = expandedUserId === user.id;
            return (
              <tr
                key={user.id}
                className={isExpanded ? `${classes.row} ${classes.expanded}` : classes.row}
                onClick={() => onToggleExpanded(user.id)}
                data-testid={`users-row-${user.id}`}
              >
                <td data-label="שם תצוגה">{user.displayName}</td>
                <td data-label="שם משתמש">{user.username}</td>
                <td data-label='דוא"ל'>{user.email}</td>
                <td data-label="תפקיד">{user.role === 'admin' ? 'מנהל' : 'משתמש'}</td>
                <td data-label="חברה ראשית">{user.companyName}</td>
                <td data-label="סטטוס">
                  <span className={user.isActive ? classes.statusActive : classes.statusInactive}>
                    {user.isActive ? 'פעיל' : 'מושבת'}
                  </span>
                </td>
                <td data-label="נוצר בתאריך">{new Date(user.createdAt).toLocaleDateString('he-IL')}</td>
                <td data-label="פעולות">
                  <div className={classes.actionsCell}>
                    <button
                      type="button"
                      className={classes.editButton}
                      onClick={(event) => {
                        event.stopPropagation();
                        onEditUser(user);
                      }}
                      data-testid={`users-edit-${user.id}`}
                    >
                      ערוך
                    </button>
                    {user.isActive ? (
                      <button
                        type="button"
                        className={classes.deactivateButton}
                        onClick={(event) => {
                          event.stopPropagation();
                          onDeactivateUser(user);
                        }}
                        data-testid={`users-deactivate-${user.id}`}
                      >
                        השבתה
                      </button>
                    ) : (
                      <button
                        type="button"
                        className={classes.activateButton}
                        onClick={(event) => {
                          event.stopPropagation();
                          onActivateUser(user);
                        }}
                        data-testid={`users-activate-${user.id}`}
                      >
                        הפעלה
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
          {users.length === 0 && !isLoadingUsers && (
            <tr>
              <td colSpan={8} className={classes.empty}>
                אין משתמשים עדיין. לחץ "צור משתמש" כדי להוסיף את הראשון.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
